export const SectionHeader = ({ title, count }) => (
    <div className="d-flex justify-content-between align-items-center px-3 py-2 small text-muted text-uppercase font-weight-bold">
        <span>{title}</span>
        {count !== undefined && <span>{count} found</span>}
    </div>
);